module.exports = __webpack_public_path__ + "static/img/son1.25749700.png";